import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Truck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, fmtQty, todayIST } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Empty } from "@/components/common";

const age = (d) => Math.round((new Date(todayIST()) - new Date(d)) / 86400000);

export default function PartyPending() {
  const { can } = useAuth();
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/party-pending").then((r) => setList(r.data)); }, []);
  if (!list) return <div className="text-sm text-muted-foreground">Loading…</div>;
  return (
    <div className="space-y-4">
      <PageHeader title="Party Pending" subtitle="Cut material not yet dispatched, and cuttings still waiting for a bill number, grouped by party (oldest first).">
        {can("dispatch:create") && <Button asChild className="bg-red-600 hover:bg-red-700 text-white"><Link to="/dispatch/new" data-testid="party-pending-dispatch-btn"><Truck className="h-4 w-4 mr-1" />New dispatch</Link></Button>}
      </PageHeader>
      {!list.length && <Empty text="Nothing pending for any party" testid="party-pending-empty" />}
      <div className="grid lg:grid-cols-2 gap-4">
        {list.map((p) => (
          <div key={p.party_name} className="rounded-lg border bg-card p-4 space-y-2" data-testid={`party-pending-${p.party_name.replace(/\s+/g, "-")}`}>
            <div className="flex items-start justify-between gap-2">
              <div className="font-semibold">{p.party_name}</div>
              <div className={`text-xs rounded px-2 py-0.5 ${age(p.oldest) > 7 ? "bg-red-600/10 text-red-600" : "bg-muted"}`}>oldest {age(p.oldest)} day(s)</div>
            </div>
            {p.pieces.length > 0 && <div className="text-sm">
              <div className="text-[11px] uppercase tracking-wider text-muted-foreground mb-1">Cut pieces to dispatch · {fmtQty(p.metres)}</div>
              {p.pieces.map((x) => <div key={x.id} className="flex justify-between gap-2 border-t py-1"><span className="font-mono text-xs">{x.drum_code}</span><span className="flex-1 truncate text-muted-foreground">{x.brand} · {x.cable_size} · Bill {x.bill_no}</span><span className="font-mono">{fmtQty(x.current_balance, x.uom)}</span></div>)}
            </div>}
            {p.pending_bill.length > 0 && <div className="text-sm">
              <div className="text-[11px] uppercase tracking-wider text-red-600 mb-1">Bill number pending</div>
              {p.pending_bill.map((x) => <div key={x.id} className="flex justify-between gap-2 border-t py-1"><Link to={`/cutting/${x.id}`} className="font-mono text-xs hover:underline">{x.slip_no}</Link><span className="flex-1 truncate text-muted-foreground">{x.date} · {x.brand} · {x.cable_size}</span><span className="font-mono">{fmtQty(x.cut_length, x.uom)}</span></div>)}
            </div>}
          </div>
        ))}
      </div>
    </div>
  );
}
